import {createAction} from "@reduxjs/toolkit";

export const setGalleryPage = createAction('SET_GALLERY_PAGE');